import { models } from "powerbi-client";

import { useReportApi } from "./api/useReportApi";
import { WorkspaceResponse } from "./api/WorkspaceResponse";
import { PowerBIReportProps } from "./common/PowerBIReport";
import { useReportConfig } from "./useReportConfig";

export const usePowerBiReport = (props: PowerBIReportProps) => {
    const { reportConfig, setReportConfig } = useReportConfig(props);

    const { getReport: fetchReport } = useReportApi();

    const getReport = () => {
        return fetchReport();
    };

    const setConfig = (response?: WorkspaceResponse) => {
        if (!response) return;

        const config = {
            ...reportConfig,
            embedUrl: response.embedUrl ?? "",
            accessToken: response.embedToken.token
        };

        setReportConfig(config);
    };

    return {
        reportConfig,
        setConfig,
        getReport
    };
};
